/*=========================================================================================
  File Name: getters.js
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const accountTypes = [
  { label: 'Preschool', value: 1 },
  { label: 'Elementary School', value: 2 },
  { label: 'Middle School', value: 3 },
  { label: 'K-8', value: 4 },
  { label: 'K-12', value: 5 },
  { label: 'High School', value: 6 },
  { label: 'Church', value: 7 },
  { label: 'Team', value: 8 },
  { label: 'Studio', value: 9 },
  { label: 'University', value: 11},
  { label: 'Dance', value: 12}
]

const getters = {

  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return 'xl'
    else if (state.windowWidth >= 992) return 'lg'
    else if (state.windowWidth >= 768) return 'md'
    else if (state.windowWidth >= 576) return 'sm'
    else return 'xs'
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },

  sessionUser: state => {
    return state.sessionUser
  },

  sessionUserPermissions: state => {
    return state.sessionUserPermissions
  },

  uph: state => {
    return state.uph
  },

  sessionUserIsStudioUser: state => {
    return state.sessionUserIsStudioUser
  },

  sessionUserIsSubStudioUser: state => {
    return state.sessionUserIsSubStudioUser
  },

  sessionUserIsDirectToSchool: state => {
    return state.sessionUserIsDirectToSchool
  },

  sessionUserImmediateAccounts: state => {
    return state.sessionUserImmediateAccounts
  },

  redirectLocation: state => {
    return state.redirectLocation
  },

  impersonation: state => {
    return state.impersonation
  },

  impersonationOriginalUser: state => {
    return state.impersonationOriginalUser
  },

  bookTypeOptions: () => {
    return [
      { label: 'Saddle Stitched', value: 1},
      // We no longer offer Saddle Stitched B&W books. This is here to not break the filters, but option should be unselectable now.
      { label: 'Saddle Stitched - B&W', value: 2},
      { label: 'Soft Cover Perfect Bound', value: 3},
      { label: 'Standard Hard Cover', value: 5},
      { label: 'Smyth Hard Cover', value: 9}
    ]
  },

  // Binding options that we currently offer
  availableBookTypeOptions: () => {
    return [
      { label: 'Saddle Stitched', value: 1 },
      { label: 'Soft Cover Perfect Bound', value: 3 },
      { label: 'Standard Hard Cover', value: 5 },
      { label: 'Smyth Hard Cover', value: 9 }
    ]
  },

  ypaBookTypeOptions: () => {
    return [
      { label: 'Saddle Stitched', value: 1},
      { label: 'Soft Cover Perfect Bound', value: 3},
      { label: 'Standard Hard Cover', value: 5}
    ]
  },

  nonSizeEightBookTypeOptions: () => {
    return [
      { label: 'Soft Cover Perfect Bound', value: 3},
      { label: 'Standard Hard Cover', value: 5},
      { label: 'Smyth Hard Cover', value: 9}
    ]
  },

  ypaNonSizeEightBookTypeOptions: () => {
    return [
      { label: 'Soft Cover Perfect Bound', value: 3},
      { label: 'Standard Hard Cover', value: 5}
    ]
  },

  salesRepBookTypeOptions: () => {
    return [
      { label: 'Standard Hard Cover', value: 5},
      { label: 'Smyth Hard Cover', value: 9},
      { label: 'Soft Cover Perfect Bound', value: 3},
      { label: 'Saddle Stitched', value: 1}
    ]
  },

  creatorStudioBookTypeOptions: () => {
    return [
      { label: 'Perfect Bound', value: 3},
      { label: 'Hard Cover', value: 5}
    ]
  },

  expeditedShippingBookTypeOptions: () => {
    return [
      { label: 'Saddle Stitched', value: 1},
      { label: 'Soft Cover Perfect Bound', value: 3},
      { label: 'Hard Cover', value: 5}
    ]
  },

  coverTypeOptions: () => {
    return [
      { label: 'Simplex', value: 1 },
      { label: 'Duplex', value: 2 }
    ]
  },

  hardCoverTypeOptions: () => {
    return [{ label: 'Simplex', value: 1 }]
  },

  mementoCoverTypeOptions: () => {
    return [{ label: 'Simplex', value: 1 }]
  },

  coverStyleOptions: () => {
    return [
      { label: 'None selected', value: 0},
      { label: 'Standard Printed (Litho)', value: 1},
      { label: 'Specialty', value: 2}
    ]
  },

  coverStyleSoftCoverOptions: () => {
    return [{ label: 'N/A', value: 0}]
  },

  coverBoardWtOptions: () => {
    return [
      { label: '120pt', value: 120},
      { label: '100pt', value: 100}
    ]
  },

  coverApplicationsWalters: () => {
    return [
      { label: 'None', value: 0},
      { label: 'Spot UV', value: 3},
      { label: 'Foil - Gold', value: 11},
      { label: 'Foil - Silver', value: 12},
      { label: 'Foil - Other', value: 13},
      { label: 'Silkscreen', value: 5},
      { label: 'Embossing', value: 6},
      { label: 'Debossing', value: 7},
      { label: 'Die Cut', value: 8},
      { label: 'TouchTeq', value: 9},
      { label: 'Other', value: 10}
    ]
  },

  coverApplicationsSoftCoverWalters: () => {
    return [
      { label: 'None', value: 0},
      { label: 'Spot UV', value: 3},
      { label: 'Foil - Gold', value: 11},
      { label: 'Foil - Silver', value: 12},
      { label: 'Foil - Other', value: 13},
      { label: 'TouchTeq', value: 9},
      { label: 'Other', value: 10}
    ]
  },

  coverApplicationsDPI: () => {
    return [
      { label: 'None', value: 0},
      { label: 'Polymer', value: 1},
      { label: 'Spot UV', value: 3},
      { label: 'Foil - Gold', value: 11},
      { label: 'Foil - Silver', value: 12},
      { label: 'Foil - Other', value: 13},
      { label: 'Silkscreen', value: 5},
      { label: 'Embossing', value: 6},
      { label: 'Debossing', value: 7},
      { label: 'Die Cut', value: 8},
      { label: 'Other', value: 10}
    ]
  },

  coverApplicationsSoftCoverDPI: () => {
    return [
      { label: 'None', value: 0},
      { label: 'Spot UV', value: 3},
      { label: 'Foil - Gold', value: 11},
      { label: 'Foil - Silver', value: 12},
      { label: 'Foil - Other', value: 13},
      { label: 'Other', value: 10}
    ]
  },

  coverApplicationsMasterList: () => {
    return [
      { label: 'Scodix Polymer / Spot UV', value: 'Scodix Polymer / Spot UV'},
      { label: 'Scodix Foil', value: 'Scodix Foil'},
      { label: 'Scodix Foil - Gold', value: 'Scodix Foil - Gold'},
      { label: 'Scodix Foil - Silver', value: 'Scodix Foil - Silver'},
      { label: 'Spot UV', value: 'Spot UV'},
      { label: 'Stamped Foil', value: 'Stamped Foil'},
      { label: 'Stamped Foil - Gold', value: 'Stamped Foil - Gold'},
      { label: 'Stamped Foil - Silver', value: 'Stamped Foil - Silver'},
      { label: 'Raised UV', value: 'Raised UV'},
      { label: 'Raised Foil', value: 'Raised Foil'},
      { label: 'Raised Foil - Gold', value: 'Raised Foil - Gold'},
      { label: 'Raised Foil - Silver', value: 'Raised Foil - Silver'},
      { label: 'Embossing', value: 'Embossing'},
      { label: 'Debossing', value: 'Debossing'},
      { label: 'Die Cut', value: 'Die Cut'},
      { label: 'Leatherette', value: 'Leatherette'},
      { label: 'Silk Screen', value: 'Silk Screen'}
    ]
  },

  endsheetTypeOptions: () => {
    return [
      { label: 'None selected', value: 0},
      { label: 'Front and Back', value: 1},
      { label: 'Front Only', value: 2},
      { label: 'Back Only', value: 3}
    ]
  },

  finishTypeOptions: () => {
    return [
      { label: 'Laminate - Gloss', value: 3 },
      { label: 'Laminate - Matte', value: 4 }
    ]
  },

  saddleStitchedFinishTypeOptions: () => {
    return [{ label: 'Laminate - Gloss', value: 3 }]
  },

  allSaddleStitchedFinishTypeOptions: () => {
    return [
      { label: 'UV - Gloss', value: 1 },
      { label: 'Laminate - Gloss', value: 3 }
    ]
  },

  waltersFinishTypeOptions: () => {
    return [
      { label: 'Gloss Laminate 80# pgs', value: 99 },
      { label: 'Gloss Laminate 100# pgs', value: 98 },
      { label: 'Matte Laminate 80# pgs', value: 97 },
      { label: 'Matte Laminate 100# pgs', value: 96 },
      { label: 'Luxe Linen 80# pgs', value: 95 },
      { label: 'Luxe Linen 100# pgs', value: 94 }
    ]
  },

  saddleStitchedSizeTypeOptions: () => {
    return [{ label: '8.5" x 11"', value: 8 }]
  },

  hardCoverSizeTypeOptions: () => {
    return [
      { label: '8.5" x 11"', value: 8 },
      { label: '9" x 12"', value: 9 },
      { label: '11.5" x 8.5"', value: 11 }
    ]
  },

  softCoverSizeTypeOptions: () => {
    return [
      { label: '8.5" x 11"', value: 8 },
      { label: '9" x 12"', value: 9 }
    ]
  },

  salesRepSizeTypeOptions: () => {
    return [
      { label: '8.5" x 11"', value: 8 },
      { label: '9" x 12"', value: 9 }
    ]
  },

  personalizationTypeOptions: () => {
    return [
      { label: 'No personalization', value: 0 },
      { label: 'Name on cover', value: 1 },
      { label: 'Name and photo on cover', value: 2 },
      { label: 'Name and icons on cover', value: 4 }
    ]
  },

  personalizationTypeOptionsWoIcons: () => {
    return [
      { label: 'No personalization', value: 0 },
      { label: 'Name on cover', value: 1 },
      { label: 'Name and photo on cover', value: 2 }
    ]
  },

  personalizationTypeOptionsWalters: () => {
    return [
      { label: 'No personalization', value: 0 },
      { label: 'Name on cover', value: 1 }
    ]
  },

  yearOptions: () => {
    return [
      { label: '2025', value: 2025 },
      { label: '2024', value: 2024 },
      { label: '2023', value: 2023 },
      { label: '2022', value: 2022 },
      { label: '2021', value: 2021 },
      { label: '2020', value: 2020 },
      { label: '2019', value: 2019 },
      { label: '2018', value: 2018 },
      { label: '2017', value: 2017 },
      { label: '2016', value: 2016 }
    ]
  },

  schoolYearOptions: () => {
    return [
      { label: '2024-2025', value: 2025 },
      { label: '2023-2024', value: 2024 },
      { label: '2022-2023', value: 2023 },
      { label: '2021-2022', value: 2022 },
      { label: '2020-2021', value: 2021 },
      { label: '2019-2020', value: 2020 },
      { label: '2018-2019', value: 2019 },
      { label: '2017-2018', value: 2018 },
      { label: '2016-2017', value: 2017 },
      { label: '2015-2016', value: 2016 }
    ]
  },

  ypaSchoolYearOptions: () => {
    return [
      { label: '2024-2025', value: 2025 },
      { label: '2023-2024', value: 2024 }
    ]
  },

  discountYearOptions: () => {
    return [
      { label: '2024-2025', value: 2025 },
      { label: '2023-2024', value: 2024 },
      { label: '2022-2023', value: 2023 },
      { label: '2021-2022', value: 2022 },
      { label: '2020-2021', value: 2021 },
      { label: '2019-2020', value: 2020 }
    ]
  },

  softwareTypeOptions: () => {
    return [
      { label: 'None / PDF Submission', value: 0},
      { label: 'Pixami', value: 3},
      { label: 'Memento', value: 7},
      { label: 'Captura Yearbooks', value: 4},
      { label: 'Fluid Media', value: 5},
      { label: 'Store Only', value: 9}
    ]
  },

  // Deprecated, we don't offer ConnectMe anymore. Use softwareTypeOptions instead
  softwareTypeOptionsConnectMe: () => {
    return [
      { label: 'None / PDF Submission', value: 0},
      { label: 'Pixami', value: 3},
      { label: 'Memento', value: 7},
      { label: 'Captura Yearbooks', value: 4},
      // This is no longer an option
      { label: 'ConnectMe', value: 10},
      { label: 'Fluid Media', value: 5},
      { label: 'Store Only', value: 9}
    ]
  },

  schoolPicturesSoftwareTypeOptions: () => {
    return [
      { label: 'None / PDF Submission', value: 0},
      { label: 'Pixami', value: 3},
      { label: 'Memento', value: 7},
      { label: 'Captura Yearbooks', value: 4},
      { label: 'Fluid Media', value: 5},
      { label: 'Store Only', value: 9}
    ]
  },

  printerOptions: () => {
    return [
      { label: 'Studio Source', value: 1 },
      { label: 'Walter\'s', value: 2 },
      { label: 'HR Imaging', value: 3 }
    ]
  },

  stateOptions: (state, getters) => {
    const states = [
      { label: 'Alabama', value: 'AL', country: 'US' },
      { label: 'Alaska', value: 'AK', country: 'US' },
      { label: 'Arizona', value: 'AZ', country: 'US' },
      { label: 'Arkansas', value: 'AR', country: 'US' },
      { label: 'California', value: 'CA', country: 'US' },
      { label: 'Colorado', value: 'CO', country: 'US' },
      { label: 'Connecticut', value: 'CT', country: 'US' },
      { label: 'Deleware', value: 'DE', country: 'US' },
      { label: 'District of Columbia', value: 'DC', country: 'US' },
      { label: 'Florida', value: 'FL', country: 'US' },
      { label: 'Georgia', value: 'GA', country: 'US' },
      { label: 'Hawaii', value: 'HI', country: 'US' },
      { label: 'Idaho', value: 'ID', country: 'US' },
      { label: 'Illinois', value: 'IL', country: 'US' },
      { label: 'Indiana', value: 'IN', country: 'US' },
      { label: 'Iowa', value: 'IA', country: 'US' },
      { label: 'Kansas', value: 'KS', country: 'US' },
      { label: 'Kentucky', value: 'KY', country: 'US' },
      { label: 'Louisiana', value: 'LA', country: 'US' },
      { label: 'Maine', value: 'ME', country: 'US' },
      { label: 'Maryland', value: 'MD', country: 'US' },
      { label: 'Massachusetts', value: 'MA', country: 'US' },
      { label: 'Michigan', value: 'MI', country: 'US' },
      { label: 'Minnesota', value: 'MN', country: 'US' },
      { label: 'Mississippi', value: 'MS', country: 'US' },
      { label: 'Missouri', value: 'MO', country: 'US' },
      { label: 'Montana', value: 'MT', country: 'US' },
      { label: 'Nebraska', value: 'NE', country: 'US' },
      { label: 'Nevada', value: 'NV', country: 'US' },
      { label: 'New Hampshire', value: 'NH', country: 'US' },
      { label: 'New Jersey', value: 'NJ', country: 'US' },
      { label: 'New Mexico', value: 'NM', country: 'US' },
      { label: 'New York', value: 'NY', country: 'US' },
      { label: 'North Carolina', value: 'NC', country: 'US' },
      { label: 'North Dakota', value: 'ND', country: 'US' },
      { label: 'Ohio', value: 'OH', country: 'US' },
      { label: 'Oklahoma', value: 'OK', country: 'US' },
      { label: 'Oregon', value: 'OR', country: 'US' },
      { label: 'Pennsylvania', value: 'PA', country: 'US' },
      { label: 'Rhode Island', value: 'RI', country: 'US' },
      { label: 'South Carolina', value: 'SC', country: 'US' },
      { label: 'South Dakota', value: 'SD', country: 'US' },
      { label: 'Tennessee', value: 'TN', country: 'US' },
      { label: 'Texas', value: 'TX', country: 'US' },
      { label: 'Utah', value: 'UT', country: 'US' },
      { label: 'Vermont', value: 'VT', country: 'US' },
      { label: 'Virginia', value: 'VA', country: 'US' },
      { label: 'Washington', value: 'WA', country: 'US' },
      { label: 'West Virginia', value: 'WV', country: 'US' },
      { label: 'Wisconsin', value: 'WI', country: 'US' },
      { label: 'Wyoming', value: 'WY', country: 'US' },
      { label: 'Alberta', value: 'AB', country: 'CA'},
      { label: 'British Columbia', value: 'BC', country: 'CA' },
      { label: 'Manitoba', value: 'MB', country: 'CA' },
      { label: 'New Brunswick', value: 'NB', country: 'CA' },
      { label: 'Newfoundland and Labrador', value: 'NL', country: 'CA' },
      { label: 'Nova Scotia', value: 'NS', country: 'CA' },
      { label: 'Ontario', value: 'ON', country: 'CA' },
      { label: 'Prince Edward Island', value: 'PE', country: 'CA' },
      { label: 'Quebec', value: 'QC', country: 'CA' },
      { label: 'Saskatchewan', value: 'SK', country: 'CA' },
      { label: 'Northwest Territories', value: 'NT', country: 'CA' },
      { label: 'Nunavut', value: 'NU', country: 'CA' },
      { label: 'Yukon', value: 'YT', country: 'JP' },
      { label: 'Tokyo', value: 'TK', country: 'JP' }
    ]
    if (getters.canViewBrazilOptions) {
      const brazilianStates = [
        { label: 'Acre', value: 'AC', country: 'BR' },
        { label: 'Alagoas', value: 'AL', country: 'BR' },
        { label: 'Amapá', value: 'AP', country: 'BR' },
        { label: 'Amazonas', value: 'AM', country: 'BR' },
        { label: 'Bahia', value: 'BA', country: 'BR' },
        { label: 'Ceará', value: 'CE', country: 'BR' },
        { label: 'Distrito Federal', value: 'DF', country: 'BR' },
        { label: 'Espírito Santo', value: 'ES', country: 'BR' },
        { label: 'Goiás', value: 'GO', country: 'BR' },
        { label: 'Maranhão', value: 'MA', country: 'BR' },
        { label: 'Mato Grosso', value: 'MT', country: 'BR' },
        { label: 'Mato Grosso do Sul', value: 'MS', country: 'BR' },
        { label: 'Minas Gerais', value: 'MG', country: 'BR' },
        { label: 'Pará', value: 'PA', country: 'BR' },
        { label: 'Paraíba', value: 'PB', country: 'BR' },
        { label: 'Paraná', value: 'PR', country: 'BR' },
        { label: 'Pernambuco', value: 'PE', country: 'BR' },
        { label: 'Piauí', value: 'PI', country: 'BR' },
        { label: 'Rio de Janeiro', value: 'RJ', country: 'BR' },
        { label: 'Rio Grande do Norte', value: 'RN', country: 'BR' },
        { label: 'Rio Grande do Sul', value: 'RS', country: 'BR' },
        { label: 'Rondônia', value: 'RO', country: 'BR' },
        { label: 'Roraima', value: 'RR', country: 'BR' },
        { label: 'Santa Catarina', value: 'SC', country: 'BR' },
        { label: 'São Paulo', value: 'SP', country: 'BR' },
        { label: 'Sergipe', value: 'SE', country: 'BR' },
        { label: 'Tocantins', value: 'TO', country: 'BR' }
      ]
      states.push(...brazilianStates)
    }
    return states
  },

  countryOptions:(state, getters) => {
    const countries =  [
      { label: 'United States', value: 'US' },
      { label: 'Canada', value: 'CA' }
    ]
    if (getters.canViewBrazilOptions) {
      countries.push({ label: 'Brazil', value: 'BR' })
    }
    return countries
  },

  roleOptions: () => {
    return [
      { label: 'Studio Owner', value: 8 },
      { label: 'Studio Administrator', value: 7 },
      { label: 'Studio Contact', value: 16 },
      { label: 'School Administrator', value: 3 },
      { label: 'School Yearbook Adviser', value: 5 },
      { label: 'School Yearbook Volunteer', value: 6 },
      { label: 'School Yearbook Sales Manager', value: 22},
      { label: 'Treasurer', value: 20 }
    ]
  },

  studioRoleOptions: () => {
    return [
      { label: 'Sales Rep', value: 99 },
      { label: 'School Administrator', value: 3 },
      { label: 'School Yearbook Adviser', value: 5 },
      { label: 'School Yearbook Sales Manager', value: 22 },
      { label: 'School Yearbook Volunteer', value: 6 },
      { label: 'Studio Administrator', value: 7 },
      { label: 'Studio Contact', value: 16 },
      { label: 'Studio Owner', value: 8 },
      { label: 'Treasurer', value: 20 }
    ]
  },

  ypaUserRoles: () => {
    return [
      { label: 'School Administrator', value: 3 },
      { label: 'School Yearbook Adviser', value: 5 },
      { label: 'School Yearbook Sales Manager', value: 22},
      { label: 'School Yearbook Volunteer', value: 6 },
      { label: 'Treasurer', value: 20 }
    ]
  },

  notificationStatusOptions: () => {
    return [
      { label: 'Waiting', value: 0 },
      { label: 'Processing', value: 1 },
      { label: 'Complete', value: 2 },
      { label: 'Error', value: 3 },
      { label: 'Attention', value: 4 },
      { label: 'Addressed', value: 5 }
    ]
  },

  proofProcessingStatusOptions: () => {
    return [
      { label: 'Waiting', value: 0 },
      { label: 'Processing', value: 1 },
      { label: 'Complete', value: 2 },
      { label: 'Error', value: 3 },
      { label: 'Attention', value: 4 },
      { label: 'Addressed', value: 5 }
    ]
  },

  uploadStatusOptions: () => {
    return [
      { label: 'Waiting', value: 0 },
      { label: 'Processing', value: 1 },
      { label: 'Complete', value: 2 },
      { label: 'Error', value: 3 },
      { label: 'Attention', value: 4 },
      { label: 'Addressed', value: 5 }
    ]
  },

  orderMoveStatusOptions: () => {
    return [
      { label: 'Waiting', value: 0 },
      { label: 'Processing', value: 1 },
      { label: 'Complete', value: 2 },
      { label: 'Error', value: 3 },
      { label: 'Attention', value: 4 },
      { label: 'Addressed', value: 5 }
    ]
  },

  epubStatusOptions: () => {
    return [
      { label: 'Waiting', value: 0 },
      { label: 'Processing', value: 1 },
      { label: 'Complete', value: 2 },
      { label: 'Error', value: 3 },
      { label: 'Attention', value: 4 },
      { label: 'Addressed', value: 5 }
    ]
  },

  pricingBindingOptions: () => {
    return [
      { label: 'A', value: 'A' },
      { label: 'B', value: 'B' },
      { label: 'C', value: 'C' },
      { label: 'D', value: 'D' },
      { label: 'E', value: 'E' },
      { label: 'F', value: 'F' },
      { label: 'G', value: 'G' },
      { label: 'H (DTS)', value: 'H' },
      { label: 'I (GCI)', value: 'I' },
      { label: 'J (Fox-Mar; Deprecated)', value: 'J' },
      { label: 'O (Comm-0%)', value: 'O' },
      { label: 'P (Comm-5%)', value: 'P' },
      { label: 'K (Comm-10%)', value: 'K' },
      { label: 'L (Comm-15%)', value: 'L' },
      { label: 'M (Comm-20%)', value: 'M' },
      { label: 'N (Comm-25%)', value: 'N' }

    ]
  },

  productTypeOptions: () => {
    return [
      { label: 'Yearbook', value: 1 },
      { label: 'Dedication Ad', value: 2 },
      { label: 'Text Only Dedication', value: 3 },
      { label: 'Photo Upload Link', value: 6 }
    ]
  },

  productTypeOptionsSidebar: () => {
    return [
      { label: 'Yearbook', value: 1 },
      { label: 'Dedication Ad', value: 2 },
      { label: 'Text Only Dedication', value: 3 },
      { label: 'Photo Upload Link', value: 6 }
    ]
  },

  productTypeNameOptions: () => {
    return [
      '',
      'Yearbook',
      'Dedication Ad',
      'Text Only Dedication',
      'Photo Upload Link' // 'Link to External Resource'
    ]
  },

  productShippingTypeOptions: () => {
    return [
      { label: 'Digital Only', value: 0 },
      { label: 'Bulk ship to home / school', value: 1 }
    ]
  },

  productShippingTypeOptionsYearbookSchool: () => {
    return [{ label: 'Bulk ship to home / school', value: 1 }]
  },

  productShippingTypeOptionsYearbookStudio: () => {
    return [
      { label: 'Bulk ship to home / school', value: 1 },
      { label: 'Summer single book', value: 2 }
    ]
  },

  productPersonalizationTypeOptions: () => {
    return [
      { label: 'Name', value: 1 },
      { label: 'Name and Photo', value: 2},
      { label: 'Name and Icons', value: 4}
    ]
  },

  productPersonalizationTypeOptionsWoIcons: () => {
    return [
      { label: 'Name', value: 1 },
      { label: 'Name and Photo', value: 2}
    ]
  },

  dedicationAdTypeOptions: () => {
    return [
      { label: 'Full Page', value: 1 },
      { label: 'Half Page', value: 2},
      { label: '1/4 Page', value: 3},
      { label: '1/8 Page', value: 4}
    ]
  },

  kidsPageTypeOptions: () => {
    return [
      { label: '1/4 Page', value: 3},
      { label: '1/8 Page', value: 4}
    ]
  },

  stripeCardTypeOptions: () => {
    return [
      { label: 'Visa', value: 'visa' },
      { label: 'Mastercard', value: 'mastercard' },
      { label: 'American Express', value: 'amex' },
      { label: 'Discover', value: 'discover' }
    ]
  },

  accountTypeOptions: () => {
    return accountTypes
  },

  studioAccountTypeOptions: () => {
    return [
      ...accountTypes,
      { label: 'Sales Rep / Branch Office', value: 10 }
    ]
  },

  timezoneOptions: () => {
    return [
      { label: 'Eastern', value: 'EST' },
      { label: 'Central', value: 'CST' },
      { label: 'Mountain', value: 'MST' },
      { label: 'Pacific', value: 'PST' },
      { label: 'Hawaii', value: 'HST' }
    ]
  },

  typeWhereSoftwareCredentials: () => {
    return [
      { label: 'N/A', value: 0 },
      { label: 'School & Studio', value: 1 },
      { label: 'Studio', value: 2 }
    ]
  },

  manufacturingPlantOptions: () => {
    return [
      { label: 'Beltsville', value: 'B' },
      { label: 'Phoenix', value: 'P' }
    ]
  },

  typeWhereCreationKitOptions: () => {
    return [
      { label: 'Select a destination', value: 0 },
      { label: 'School', value: 1 },
      { label: 'Studio', value: 2 }
    ]
  },

  typeWhereCreationKitOptionsYearbookReps: () => {
    return [
      { label: 'Select a destination', value: 0 },
      { label: 'School', value: 1 },
      { label: 'Yearbook rep', value: 2 }
    ]
  },

  typeEnvelopeOptions: () => {
    return [
      { label: 'None', value: 0 },
      { label: 'Blank', value: 1 },
      { label: 'Printed', value: 2 }
    ]
  },

  timezoneOffset: state => {
    let offset = 0
    if (state.sessionUser.timezone === 'EST') {
      offset = -300
    } else if (state.sessionUser.timezone === 'CST') {
      offset = -360
    } else if (state.sessionUser.timezone === 'MST') {
      offset = -420
    } else if (state.sessionUser.timezone === 'PST') {
      offset = -480
    } else if (state.sessionUser.timezone === 'JST') {
      offset = 540
    }
    return offset
  },

  onlineOrderPaymentOptions: () => {
    return [
      { label: 'Credit Card', value: 2 },
      { label: 'Check', value: 3 },
      { label: 'Cash', value: 4 }
    ]
  },

  onlineOrderPaymentAddOptions: () => {
    return [
      { label: 'Check', value: 3 },
      { label: 'Cash', value: 4 }
    ]
  },

  onlineOrderShippingTypeOptions: () => {
    return [
      { label: 'Digital only', value: 0 },
      { label: 'Bulk order - Ships to school', value: 1 },
      { label: 'Bulk order - Ships to home', value: 3 },
      { label: 'Summer single order', value: 2 }
    ]
  },

  orderTypeOptions: () => {
    return [
      { label: 'Production', value: 1 },
      { label: 'Proof', value: 0 },
      { label: 'Redo', value: 3 },
      { label: 'Sample', value: 2 },
      { label: 'Summer single order', value: 5 }
    ]
  },

  orderStatusOptions: () => {
    return [
      { label: 'Error', value: -2 },
      { label: 'Processing', value: -1 },
      { label: 'Waiting', value: 0 },
      { label: 'Submitted', value: 1 },
      { label: 'In Production', value: 11 },
      { label: 'Shipped', value: 2 },
      { label: 'Delivered', value: 3 },
      { label: 'School Copies Delivered', value: 6 },
      { label: 'Studio Copies Delivered', value: 7 },
      { label: 'Both Copies Delivered', value: 8 },
      { label: 'Canceled in Manufacturing', value: 9 },
      { label: 'On Hold in Manufacturing', value: 10 },
      { label: 'Lost in Transit', value: 12 }
    ]
  },

  momentTimezone: state => {
    let tz = 'America/Chicago'
    if (state.sessionUser.timezone === 'EST') {
      tz = 'America/New_York'
    } else if (state.sessionUser.timezone === 'MST') {
      tz = 'America/Denver'
    } else if (state.sessionUser.timezone === 'PST') {
      tz = 'America/Los_Angeles'
    } else if (state.sessionUser.timezone === 'HST') {
      tz = 'Pacific/Honolulu'
    } else if (state.sessionUser.timezone === 'JST') {
      tz = 'Asia/Tokyo'
    }
    return tz
  },

  invoiceProductTypeOptions: () => {
    return [
      { label: 'School Yearbooks', value: 1 },
      { label: 'Church Directories', value: 2 },
      { label: 'Software Licenses', value: 6 },
      { label: 'Yearbook Creation Kits', value: 3 },
      { label: 'Money Collection Envelopes', value: 4 },
      { label: 'Sales Posters', value: 5 }
    ]
  },

  discountTypeOptions: () => {
    return [
      { label: 'Percentage', value: 1 },
      { label: 'Dollar', value: 2 }
    ]
  },

  studioPaymentOptions: () => {
    return [
      { label: 'Online Sales Credits', value: 'Online Sales Credits' },
      { label: 'Credit Card', value: 'Credit Card' },
      { label: 'ACH', value: 'ACH' },
      { label: 'Check', value: 'Check' }
    ]
  },

  dockTypeOptions: () => {
    return [
      { label: 'Unknown', value: 0 },
      { label: 'Yes', value: 1 },
      { label: 'No', value: 2 }
    ]
  },

  manufacturerOptions: () => {
    return [
      { label: 'Acutrack', value: 'ACUL' },
      { label: 'Advertek Inc. - Woodbridge', value: 'ADVW' },
      { label: 'Advertek Inc. - Niagra Falls', value: 'ADVN' },
      { label: 'Alexander\'s - Lindon', value: 'APAL' },
      { label: 'APS', value: 'APSC' },
      { label: 'Bennett Graphics', value: 'BGT' },
      { label: 'BR Printers - Independence', value: 'BRPI' },
      { label: 'BR Printers - San Jose', value: 'BRPS' },
      { label: 'Corefact - Louisville', value: 'CFTL' },
      { label: 'Corefact - San Leandro', value: 'CFTS' },
      { label: 'Digital Lizard', value: 'DL' },
      { label: 'Digital Lizard - Hayden', value: 'DLH' },
      { label: 'Digital Lizard - Las Vegas', value: 'DLLV' },
      { label: 'DPI', value: 'DPI' },
      { label: 'DPI - Beltsville', value: 'DPIB' },
      { label: 'DPI - Phoenix', value: 'DPIP' },
      { label: 'Hudson Printing', value: 'HPS' },
      { label: 'Impactica', value: 'IMPE' },
      { label: 'Mimeo - Memphis', value: 'MIMM' },
      { label: 'Office Depot - Dallas', value: 'ODGP' },
      { label: 'Office Depot - Seattle', value: 'ODS' },
      { label: 'On Press', value: 'ONPP' },
      { label: 'Superior', value: 'SUP' }
    ]
  },

  commissionTypeOptions: () => {
    return [
      { label: 'Select a commission %', value: '' },
      { label: '0%', value: 0 },
      { label: '5%', value: 5 },
      { label: '10%', value: 10 },
      { label: '15%', value: 15 },
      { label: '20%', value: 20 },
      { label: '25%', value: 25 }
    ]
  },

  pricingAdjustmentOptions: () => {
    return [
      { label: 'Per Book', value: 1 },
      { label: 'Total Dollar', value: 2 },
      { label: 'Percentage of Invoice', value: 3 },
      { label: 'Free Books', value: 4 }
    ]
  },

  superAdminResources: () => {
    return [
      { label: 'Select a resource', value: '' },
      { label: 'Account', value: 'Account' },
      { label: 'Project', value: 'Project' },
      { label: 'Proof', value: 'Proof' },
      { label: 'Order', value: 'Order' },
      { label: 'User', value: 'User' }
    ]
  },

  whereDoIStartYPASteps: () => {
    return [
      {
        target: '.v-tour-ypa-link',
        content: 'Click here to submit a YPA',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartAccountSteps: () => {
    return [
      {
        target: '.v-tour-accounts-link',
        content: 'Click here to manage your accounts',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartUserSteps: () => {
    return [
      {
        target: '.v-tour-users-link',
        content: 'Click here to manage your users',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartProofSteps: () => {
    return [
      {
        target: '.v-tour-proofs-link',
        content: 'Click here to proof your schools\' projects',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartProofTourSchoolSteps: () => {
    return [
      {
        target: '.v-tour-my-account-link',
        content: 'Click here and scroll to the Proofs section',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartOrderTourSchoolSteps: () => {
    return [
      {
        target: '.v-tour-my-account-link',
        content: 'Click here and scroll to the Orders section',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartOnlineSalesTourSchoolSteps: () => {
    return [
      {
        target: '.v-tour-my-account-link',
        content: 'Click here and then click the Sales tab',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartOnlineSalesSetupTourSchoolSteps: () => {
    return [
      {
        target: '.v-tour-my-account-link',
        content: 'Click here and then click the Store tab',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartOrderSteps: () => {
    return [
      {
        target: '.v-tour-order-status-link',
        content: 'Click here to track your schools\' orders',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartOnlineSalesSteps: () => {
    return [
      {
        target: '.v-tour-online-sales-link',
        content: 'Click here to review your schools\' online sales',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartOnlineSalesSetupSteps: () => {
    return [
      {
        target: '.v-tour-accounts-link',
        content: 'Find the account and click on the Store tab',
        params: {
          placement: 'right'
        }
      }
    ]
  },

  whereDoIStartSoftwareSteps: () => {
    return [
      {
        target: '#studio-software-card',
        content: 'Here you can find all your yearbook software details',
        params: {
          placement: 'bottom'
        }
      }
    ]
  },

  whereDoIStartSoftwareSchoolSteps: () => {
    return [
      {
        target: '#school-software-card',
        content: 'Here you can find all your yearbook software details',
        params: {
          placement: 'bottom'
        }
      }
    ]
  },

  ypaHowToStartSteps: () => {
    return [
      {
        target: '#ypa-renewal-button',
        content: 'Click here to submit an agreement for an existing dashboard account.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '#ypa-new-account-button',
        content: 'Click here to add a new account to the dashboard.',
        params: {
          placement: 'bottom'
        }
      }
    ]
  },

  ypaProjectInformationSteps: () => {
    return [
      {
        target: '#design-location-label',
        content: 'Choose if the school will help with the design of the yearbook or if the book will be created by the studio.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#software-credentials-label',
        content: 'Specify where the yearbook software credentials should be sent. The majority of studios select School and Studio.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#split-binding-label',
        content: 'If your school requires both hard cover and soft cover yearbooks, select this option.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#binding-type-label',
        content: 'Select your desired binding type.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#size-type-label',
        content: 'Our most common size is 8.5"x11", but you can select a different size if offered for your binding type.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#finish-type-label',
        content: 'Select a cover finish from the list below which is filtered by your binding type.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#page-count-input',
        content: 'Enter your desired page count. This is an estimate.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#book-count-input',
        content: 'Enter your desired book count. This is an estimate for the number of school copies you need.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#extra-count-input',
        content: 'Enter your desired studio copy count. This is an estimate.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#personalization-type-label',
        content: 'Select a personalization option if your school would like to offer this add-on.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '.price-floating-container',
        content: 'Updating these project fields automatically updates your total price. Click DETAILS for more information.',
        offset: -200, // push the page 200px lower than the actual element
        params: {
          placement: 'left'
        }
      },
      {
        target: '#hard-copy-proof-label',
        content: 'Choose this option if you would like to receive two printed hard copy proofs before receiving your final order. This is highly recommended.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#where-to-ship-label',
        content: 'Choose where you would like to ship your order. If you selected studio copies and select ship to school, your studio copies will be shipped to your studio address.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#online-sales-label',
        content: 'Select if you would like to set up an online store for your account. This allows you to take yearbook orders online.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '#delivery-date-label',
        content: 'Select when the school requires the yearbooks be delivered. This will drive the logic behind when you should submit your book for review and submit your order to production.',
        offset: -500, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      }
    ]
  },

  proofTourSteps: () => {
    return [
      {
        target: '[proof-tour-step="1"]',
        content: 'This flipbook is how your yearbook will look once it is printed.',
        offset: -100, // push the page 200px lower than the actual element
        params: {
          placement: 'left'
        }
      },
      {
        target: '[proof-tour-step="1"]',
        content: 'Use the proof toolbar to jump to a page and submit/review comments. You should also download the hi-res cover and pages PDFs to make sure each page is full bleed.',
        offset: -100, // push the page 200px lower than the actual element
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '[proof-tour-step="7"]',
        content: 'This is the proof\'s cover spread. This view allows you to see the spine and fold lines (these will not be printed). It is particularly useful to review spine text if it is included in your design.',
        params: {
          placement: 'top'
        }
      },
      {
        target: '[proof-tour-step="2"]',
        content: 'This is the proof status. Click to see who has approved, rejected, or needs to review the proof.',
        offset: -300, // push the page 200px lower than the actual element
        params: {
          placement: 'left'
        }
      },
      {
        target: '[proof-tour-step="3"]',
        content: 'Once you’ve reviewed all pages and everything looks good, click here to approve the proof.',
        offset: -300, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '[proof-tour-step="4"]',
        content: 'If any changes are needed, click here to reject the proof. This will unlock your book in the yearbook software so you can make edits.',
        offset: -300, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '[proof-tour-step="5"]',
        content: 'Once the proof is approved, if you have permission to place an order, the order button will become active.',
        offset: -300, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      },
      {
        target: '[proof-tour-step="8"]',
        content: 'That\'s all there is to it!',
        offset: -300, // push the page 200px lower than the actual element
        params: {
          placement: 'top'
        }
      }
    ]
  },

  productSetupPricingSteps: () => {
    return [
      {
        target: '#add-price-record-button',
        content: 'Optional: Add tiered pricing to encourage early purchasing as price increases over time.',
        params: {
          placement: 'left'
        }
      }
    ]
  },

  sessionSchoolUserHasSoftware: (state, getters) => {
    let hasSoftware = false
    for (let i = 0; i < getters.sessionUserImmediateAccounts.length; i++) {
      const ia = getters.sessionUserImmediateAccounts[i]
      if (ia.typeSoftware > 0 && ia.typeWhereCreated === 1 && ia.typeSoftware !== 9 && !state.sessionUserIsStudioUser) {
        hasSoftware = true
        break
      }
    }
    return hasSoftware
  },

  sessionSchoolUserHasNoSoftware: (state, getters) => {
    return !getters.sessionSchoolUserHasSoftware && !state.sessionUserIsStudioUser
  },

  mfaRequired: (state, getters) => {
    return state.mfaRequired
  },

  mfaValidated: (state, getters) => {
    return state.mfaValidated
  },

  canViewBrazilOptions: state => {
    if (state.sessionUserPermissions.bSuperAdmin) {
      return true
    }

    const isBrazilianStudioConnected = (account) => {
      if (account.country === 'BR') {
        return true
      }
      
      if (account.parentAccount) {
        if (account.parentAccount.country === 'BR') {
          return true
        }
        
        if (account.parentAccount.parentAccount) {
          return account.parentAccount.parentAccount.country === 'BR'
        }
      }
      return false
    }
    return state.sessionUserImmediateAccounts.some(isBrazilianStudioConnected)
  }
}

export default getters
